import React from "react";
import ReactDatePicker from "../../../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "../redux/attritionAndCancelReasonsSaga";
import { useSelector, useDispatch } from "react-redux";

export const SingleDatePicker = () => {
  const dispatch = useDispatch();

  const date = useSelector((state) => state.attritionAndCancelReasons.selectedFilters.date);
  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.attritionAndCancelReasons.currentUser
  );

  return (
    <ReactDatePicker
      calendarEndDate={calendarEndDate}
      minDate={calendarStartDate}
      startDate={date}
      updateDates={(data) => dispatch(actionCreators.updateFilter({ key: "date", data }))}
    />
  );
};
